// @ts-check

import React from 'react';
import { array, object } from 'prop-types';
import USER from 'containers/pages/profile/ts/profileEditorEnum';
import ProfilePaper from './ProfilePaper';
import Grid from '@mui/material/Grid';
import ProfileTextField from './ProfileTextField';
import ProfileAutocomplete from './ProfileAutocomplete';
import Typography from '@mui/material/Typography';

/**
 * @component ProfilePersonal
 * @param {Object} props
 * @param {ProfileUser} props.user
 * @param {LanguageType[]} props.languages
 * @param {ContactType[]} props.contactTypes
 * @param {RoleGroupType[]} props.roleGroups
 * @returns {JSX.Element}
 */
function ProfilePersonal({ user, languages, contactTypes, roleGroups }) {
	return (
		<ProfilePaper>
			<Typography variant="button">Personal Infomation</Typography>
			<Grid container spacing={2}>
				<Grid item lg={4} xs={12}>
					<ProfileTextField
						label="Work Phone"
						value={`${user[USER.PHONE_WORK_DIAL_CODE]} ${user[USER.PHONE_WORK]} ${
							user[USER.PHONE_WORK_EXT]
						}`}
					/>
				</Grid>
				<Grid item lg={4} xs={12}>
					<ProfileTextField
						label="Mobile Phone"
						value={`${user[USER.PHONE_MOBILE_DIAL_CODE]} ${user[USER.PHONE_MOBILE]} ${
							user[USER.PHONE_MOBILE_EXT]
						}`}
					/>
				</Grid>
				<Grid item lg={4} xs={12}>
					<ProfileTextField
						label="Other Phone"
						value={`${user[USER.PHONE_OTHER_DIAL_CODE]} ${user[USER.PHONE_OTHER]} ${
							user[USER.PHONE_OTHER_EXT]
						}`}
					/>
				</Grid>
			</Grid>
			<Grid container spacing={2}>
				<Grid item lg={4} xs={12}>
					<ProfileTextField label="Work Email" value={user[USER.EMAIL_WORK]} />
				</Grid>
				<Grid item lg={4} xs={12}>
					<ProfileTextField label="Personal Email" value={user[USER.EMAIL_PERSONAL]} />
				</Grid>
				<Grid item lg={4} xs={12}>
					<ProfileTextField label="Other Email" value={user[USER.EMAIL_OTHER]} />
				</Grid>
			</Grid>
			<Grid container spacing={2}>
				<Grid item lg={4} xs={12}>
					<ProfileAutocomplete
						name="name"
						label="Languages"
						options={languages}
						values={languages.filter((language) =>
							user.languageIds.some((id) => language.id === id),
						)}
					/>
				</Grid>
				<Grid item lg={4} xs={12}>
					<ProfileAutocomplete
						name="Title"
						label="Contact Types"
						options={contactTypes}
						values={contactTypes.filter((contactType) =>
							user.contactTypes.some((id) => contactType.Id === id),
						)}
					/>
				</Grid>
				<Grid item lg={4} xs={12}>
					<ProfileAutocomplete
						name="name"
						label="User Role Groups"
						options={roleGroups}
						values={roleGroups.filter((group) => user.roles.some((id) => group.id === id))}
					/>
				</Grid>
			</Grid>
		</ProfilePaper>
	);
}

ProfilePersonal.propTypes = {
	user: object,
	languages: array,
	contactTypes: array,
	roleGroups: array,
};

export default ProfilePersonal;
